import { create } from "zustand";

interface SidebarState {
  isOpenSidebarLeft: boolean;
  isOpenSidebarRight: boolean;
}

interface SidebarActions {
  toggleSidebarLeft: () => void;
  toggleSidebarRight: () => void;
}

export type SidebarStore = SidebarState & SidebarActions;

export const useSidebarStore = create<SidebarStore>((set) => ({
  isOpenSidebarLeft:
    typeof window !== "undefined" ? window.innerWidth > 1024 : false,
  isOpenSidebarRight: false,
  toggleSidebarLeft: () =>
    set((state) => ({ isOpenSidebarLeft: !state.isOpenSidebarLeft })),
  toggleSidebarRight: () =>
    set((state) => ({ isOpenSidebarRight: !state.isOpenSidebarRight })),
}));
